/* 🤖 this file was generated by svg-to-ts */
export const svgFacebook: {
    name: "facebook";
    data: string;
} = {
    name: "facebook",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__facebook" viewBox="0 0 8.9 18.9"><path d="M5.2 18.6V9.4h2.5l.4-3H5.2V4.9c0-1 .4-1.6 1.4-1.6h1.6V.5C8 .4 7 .3 5.8.3c-2.4 0-3.7 2-3.7 4.3v1.8h-2v3h2v9.1l3.1.1z" class="ng__st0"/></symbol></svg>`,
};
